import React from 'react';
import classNames from 'classnames';
import SubscriptionManagementLinks from '../subscription_management_links/subscription_management_links';
const styles = require('./business_general_pricing_card.module.scss');

interface Props {
  businessEmail: string;
  pricingPlanUrl: string;
  manageSubscription?: boolean;
  cancelSubscriptionUrl?: string;
  customerPortalUrl?: string;
  pendingCancellation?: boolean;
  planPeriodDays?: number;
  inTrial?: boolean;
  subscriptionPlan?: {
    in_trial?: boolean;
    subscription_product?: {
      with_duration_contract?: boolean;
    };
    end_date?: string;
  };
  isPartnershipPlan?: boolean;
  cancellationReasons?: Array<{ value: string; label: string }>;
}

export default function BusinessGeneralPricingCard(props: Props) {
  return (
    <div className={styles.container}>
      <div className={styles.boxCompany}>
        <div className={styles.middleContainer}>
          <div className={classNames(styles.description, styles.descriptionBusinessGeneral)}>
            {!props.manageSubscription && (
              <p className={styles.descriptionBusinessGeneralText}>
                To know more about our pricing plans, check our&nbsp;
                <a
                  href={props.pricingPlanUrl}
                  className={styles.companySettingsLink}
                  rel='noreferrer'
                >
                  pricing page
                </a>
                .
              </p>
            )}
            <p className={styles.descriptionBusinessGeneralText}>
              If you want to change, extend or have any other question about your plan,&nbsp;
              <a
                href={`mailto:${props.businessEmail}`}
                className={styles.companySettingsLink}
                target='_blank'
                rel='noreferrer'
              >
                contact us
              </a>
              .
            </p>
            {props.manageSubscription && (
              <SubscriptionManagementLinks
                customerPortalUrl={props.customerPortalUrl}
                cancelSubscriptionUrl={props.cancelSubscriptionUrl}
                pendingCancellation={props.pendingCancellation}
                linkClassName={styles.companySettingsLink}
                textClassName={styles.descriptionBusinessGeneralText}
                planPeriodDays={props.planPeriodDays}
                inTrial={props.inTrial}
                subscriptionPlan={props.subscriptionPlan}
                cancellationReasons={props.cancellationReasons}
              />
            )}
            {props.isPartnershipPlan && (
              <p className={styles.descriptionBusinessGeneralText}>
                Want to upgrade your plan?&nbsp;
                <a
                  href={props.pricingPlanUrl}
                  className={styles.companySettingsLink}
                  rel='noreferrer'
                >
                  View pricing plans
                </a>
                .
              </p>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
